import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { TokenService } from '../services/token.service';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

/**
 * ✅ Auth Interceptor - Adds Bearer token to all requests
 * Extracts token from search API response header
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  
  // List of URLs that should NOT send Bearer token
  const excludedUrls = ['/status'];

  // URL that provides the token in response header
  const searchApiUrl = '/search';

  // Check if current request should be excluded
  const shouldExclude = excludedUrls.some(url => req.url.includes(url));

  // Clone request with token (if not excluded)
  let clonedRequest = req;
  
  if (!shouldExclude) {
    const token = tokenService.getToken();

    if (token) {
      clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }

  // Handle response and extract token from search API
  return next(clonedRequest).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        // Check if this is a search API response
        if (req.url.includes(searchApiUrl)) {
          // Extract Authorization header from response
          const authHeader = event.headers.get('Authorization');
          
          if (authHeader) {
            const token = tokenService.extractTokenFromHeader(authHeader);            
            if (token) {
              tokenService.setToken(token);
            }
          }
        }
      }
    }),
     // Handle 401 Unauthorized errors
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        
        // Clear token on 401
        tokenService.clearToken();
        router.navigate(['/eclaim']);
      }
      
      return throwError(() => error);
    })
  );
};